const PageWrap: React.FC<React.PropsWithChildren> = ({ children }) => {
    return <div>{children}</div>;
};

export default PageWrap;
